<template>
	<div>
		<el-dialog title="新建手动上传任务" :visible.sync="confirmManualDialogShow" width="600px" :center="true" :close-on-click-modal="false" @close="clear">
			<el-form :model="manualConfigForm" ref="manualConfigForm" :rules="rules" label-position="left" label-suffix="：" label-width="120px">
				<el-form-item label="项目名称">
					{{manualConfigForm.title}}
				</el-form-item>
				<el-form-item label="任务名称" prop="data_set_name">
					<el-input v-model="manualConfigForm.data_set_name"></el-input>
				</el-form-item>
				<el-form-item label="上传路径" prop="oss_prefix">
					<el-input v-model="manualConfigForm.oss_prefix" type="textarea" :rows="2"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="manualProjectAction" size="mini">确认</el-button>
				<el-button type="danger" @click="confirmManualDialogShow=false" size="mini">取消</el-button>
			</span>
		</el-dialog>
		<el-dialog title="数据处理流程" :visible.sync="confirmConfigDialogShow" width="400px" :center="true" :close-on-click-modal="false" :close-on-press-escape="false">
			<el-form :rules="rules" label-position="left" label-suffix="：" label-width="100px">
				<el-form-item label="流程状态">
					<el-select v-model="workflow" placeholder="请选择数据处理流程" style="width:100%">
		    			<el-option
		      				v-for="item in workflows"
		      				:key="item.value"
		      				:label="item.label"
		      				:value="item.value">
		    			</el-option>
		  			</el-select>
		  		</el-form-item>
		  		<p>预计各节点所需时间：</p>
		  		<el-form-item v-for="(opt, $idx) in curOption" :key="opt.sequence" :label="opt.option.title">
					<template  v-if="$idx !== curOption.length - 1" >
						<el-input-number v-model="opt.need_days" style="width: 80%" :step="0.5" :min="0" :precision="1" @change="inputNumberChange($idx)"></el-input-number>&nbsp;&nbsp;天
					</template>
		  		</el-form-item>
		  	</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="configProjectAction" size="mini">确认</el-button>
				<el-button type="danger" @click="confirmConfigDialogShow=false" size="mini">取消</el-button>
			</span>
		</el-dialog>
		<el-dialog title="质检报告" :visible.sync="viewReportDialogShow" width="30%" :center="true" :close-on-click-modal="false">
			<el-table border :data="viewReportData" style="width: 100%">
				<el-table-column prop="check_time" label="时间" align="center" :formatter="formateDate"> </el-table-column>
				<el-table-column prop="report_name" label="报告名称" align="center">
					<template slot-scope="scope">
						<span v-if="scope.row.url!==''"><a :href="scope.row.url">{{scope.row.name}}</a></span>
						<p v-else style="text-decoration: underline;cursor: pointer;color: #5D73F6" @click="viewReportDetail(scope.row)">{{scope.row.name}}</p>
					</template>
				</el-table-column>b
				<el-table-column prop="backflow_node" label="生成环节" align="center">
					<template slot-scope="scope">
						<span>{{translateCode(scope.row)}}</span>
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>
		<div class="content">
			<div class="topdiv" v-if="projectTitle">
				<label class="topdiv-title">{{projectTitle}}</label>
				<div style="margin-top:30px;display:flex;margin-left:auto;margin-right:32px;">
					<el-button style="margin-right:5px;height:32px;font-size:14px;padding-top:8px;border-radius:2px" v-for="(item,index) in operationButtons"
					 :key="index" @click="operationButtonAction(item)" type="primary">{{item.title}}</el-button>
				</div>
			</div>

			<div class="line" style="margin-top:18px"></div>

			<div class="topdiv" >
				<label class="topdiv-title">数据处理流程</label>
				<div class="workflows" style="margin-left:60px;margin-top: 32px">
					<template v-for="(option,index) in options" v-if="index !== options.length">
						<div style="display: inline-block">
							<el-button type="primary" plain size="mini">{{option.option.title}}</el-button>
							<p style="text-align: center;font-size: 12px;">{{index !== options.length - 1 ? option.need_days + '天' : '&nbsp;'}}</p>
						</div>
						<i v-if="index !== options.length - 1" class="el-icon-arrow-right" style="vertical-align: top;color:#0081EC"></i>
					</template>
					<span v-if="!options.length">暂无 </span>
				</div>
			</div>

			<div class="topdiv" >
				<label class="topdiv-title">数据回流任务</label>
			</div>
			<div class="topdiv" style="margin-top: 18px">
				<el-table :data="data_sets" style="width: 100%">
					<el-table-column prop="created_at" label="创建时间" :sortable="false" align="left" width="100" :formatter="formateDate"> </el-table-column>
					<el-table-column prop="collect_date" label="采集时间" align="left" width="100" :formatter="formateDate"> </el-table-column>
					<el-table-column prop="data_set_name" label="任务名称" align="left" width="100"> </el-table-column>
					<el-table-column prop="id" label="任务id" align="left" width="100"> </el-table-column>
					<el-table-column prop="local_dir" label="本地路径" align="left"  width="200">
					</el-table-column>
					<el-table-column prop="oss_prefix" label="上传路径" align="left" width="200">
						<template slot-scope="scope">
							{{ scope.row.oss_prefix }}
							<div v-if="scope.row.hubble_url">
								<el-button
									type="text"
									class="copy-btn"
									@click="moreDetail(scope.row)"
									>更多版本</el-button
								>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="流程进度">
						<template slot-scope="scope">
							<div style="flex-wrap: wrap;display:flex">							
								<template v-for="(option,index) in scope.row.options" v-if="index !== scope.row.options.length - 1">
									<el-button :type="option.state===0?'primary':(option.state===1?'success':(option.state===3?'warning':'danger'))" plain size="mini" @click="updateState(scope.row.id, option, scope.row.options)">{{option.option.title}}</el-button>
									<i class="el-icon-arrow-right" style="color:#0081EC"></i>
								</template>
								<el-button type="primary" plain size="mini" v-if="scope.row.options.length"
									@click="updateState(scope.row.id, scope.row.options[scope.row.options.length - 1], scope.row.options)"
									:type="scope.row.options[scope.row.options.length - 1].state===0?'primary':(scope.row.options[scope.row.options.length - 1].state===1?'success':(scope.row.options[scope.row.options.length - 1].state===3?'warning':'danger'))">{{scope.row.options[scope.row.options.length - 1].option.title}}</el-button>
							</div>
						</template>
					</el-table-column>
					<el-table-column  label="质检报告" align="center" width="100">
						<template slot-scope="scope">
							<el-button type="text" @click="viewReport(scope.row)">查看</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="pagination">
				<el-pagination style="float:right" small background @current-change="pageChange" layout="prev, pager, next"
				 :total="total" :page-size="per_page" v-show="total>1"></el-pagination>
			</div>
			<el-dialog
				:visible.sync="moreUrl"
				width="550px"
				center
			>
				<el-row style="margin-bottom: 20px;">
					<el-col :span="10">数据集详情页:</el-col>
					<el-col :span="14" style="word-wrap:break-word">
						<a class="more-link" :href="moreData.hubble_url" target="_blank">
							{{moreData.hubble_url}}
						</a>
					</el-col>
				</el-row>
				<el-row style="margin-bottom: 20px;">
					<el-col :span="10">版本</el-col>
					<el-col :span="14">OSS路径</el-col>
				</el-row>
				<div class="divider"></div>
				<el-row style="margin-bottom: 20px;" v-for="(item, idx) in moreData.list" :key="idx">
					<el-col :span="10">{{item.name}}</el-col>
					<el-col :span="14" class="more-url" style="word-wrap:break-word">
						<span>
							{{item.oss_path}}
						</span>
					</el-col>
				</el-row>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="moreUrl = false">关闭</el-button>
				</span>
			</el-dialog>
		</div>

		<el-dialog
			:visible.sync="centerDialogVisible"
			width="400px"
			center
			custom-class="err-dialog"
		>
			<span style="padding:25px;">
				<el-row>
					<el-col :span="3">
						<i class="el-icon-error" style="color:red;font-size:20px;vertical-align:top;"></i>
					</el-col>
					<el-col :span="21">
						创建bucket失败，请及时联系开发同学进行处理！
					</el-col>
				</el-row>
			</span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="centerDialogVisible = false">确认</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<style lang="scss" scoped>
	.content {
		text-align: left;
		margin-top: 15px;
		width: 1200px;
		height: 100%;
		padding: 59px 30px;
		margin-left: auto;
		margin-right: auto;
		background-color: #ffffff;
		border-bottom: 15px #f0f2f5 solid;

		.topdiv {
			display: flex;

			.topdiv-title {
				font-size: 20px;
				font-weight: 500;
				margin-left: 32px;
				margin-top: 32px;
			}

			.el-icon-arrow-right {
				margin-top: 5px;
			}
		}

		.line {
			height: 1px;
			margin-top: 12px;
			margin-left: 32px;
			margin-right: 32px;
			padding: 0px;
			background-color: #e8e8e8;
		}

		.pagination {
			background-color: #ffffff;
			width: 100%;
			margin-top: 73px;
			height: 40px;
		}
	}

	.more-url{
    .more-copy-btn {
        padding: 0;
    }
	}
	.more-link {
		color: #3595FB !important;
		text-decoration: none;
	}
	.divider {
		display: block;
		height: 1px;
		width: 100%;
		margin: 24px 0;
		background-color: #dcdfe6;
		position: relative;
	}

</style>

<script>
	import CONSTANTS from "@/js/utils/constants";
	import config from "@/js/utils/config";
	import ProjectOperationFlowUtils from "@/js/utils/projectOperationFlow";
	import {MessageBox} from "element-ui";
	import {Loading} from "element-ui";
	import CommonSrv from "@/js/utils/common-service";
	import eventBus from "@/js/utils/eventBus";
	import ProjectServices from '@/js/modules/project/services/project-services'
	export default {
		name: "ProjectDetail",
		components: {
		},
		computed: {
			curOption() {
				let options;
				this.workflows.forEach(workflow => {
					if (this.workflow === workflow.value) {
						options =  JSON.parse(JSON.stringify(workflow.options));
					}
				});
				return options;
			}
		},
		data() {
			return {
				COLLECT_STATE: ProjectOperationFlowUtils.COLLECT_STATE,
				confirmConfigDialogShow: false,
				confirmManualDialogShow: false,
				viewReportDialogShow: false,
				data_sets: [],
				viewReportData: [],
				operationButtons: [],
				projectId: '',
				projectState: -1,
				projectTitle: '',
				procedure_state: 0,
				job_uid: '',
				options: [],
				page: 1,
				per_page: 15,
				total: 0,
				manualConfigForm: {
					create_type: 1,
					job_uid: '',
					title: '',
					region: '',
					data_set_name: undefined,
					oss_prefix: undefined
				},
				workflows: [],
				workflow: '',
				rules: {
					oss_prefix: [
						{required: true, message: '请填写上传路径'}
					],
					data_set_name: [
						{required: true, message: '请填写任务名称'}
					]
				},
				loadingInstance: null,
				moreUrl: false, // 更多版本渲染,
				moreData: {
					hubble_url: '',
					list: []
				},
				centerDialogVisible: false
			};
		},


		created() {
			let loadingInstance = Loading.service({
				lock: true,
				text: "努力处理数据中，请稍候",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.7)"
			});
			this.projectId = parseInt(this.$route.query.uid);
			this.frompage = this.$route.query.frompage;
			let url = config.api.jobs + '/' + this.projectId;
			this.HttpUtils.get(url, {})
				.then(result => {
					this.procedure_state = result.data.procedure_state;
					this.options = result.data.options || [];
					this.job_uid = result.data.job_uid;
					this.manualConfigForm.region = result.data.region;
					this.manualConfigForm.job_uid = result.data.job_uid;
					this.manualConfigForm.title = result.data.title;
					this.setProjectInfo(result.data.job_uid + result.data.title, result.data.state);
					return this.loadDateSets();
				})
				.then(() => {
					loadingInstance.close();
				})
				.catch(execption => {
					loadingInstance.close();
					console.log(execption);
				});
        },

		beforeRouteLeave(to, from, next) {
			if (this.loadingInstance) {
				this.loadingInstance.close();
			}
			next();
		},

		methods: {
			// 打开更多版本框
			moreDetail({ id, hubble_url }) {
				this.moreData.list = []
				this.moreUrl = true
				this.moreData.hubble_url = hubble_url
				ProjectServices.getMoreData(id).then(res => {
					this.moreData.list = res.data.revisions
				})
			},
			inputNumberChange(idx) {
				this.workflows.forEach(workflow => {
					if (this.workflow === workflow.value) {
						workflow.options[idx].need_days = this.curOption[idx].need_days;
					}
				});
			},

			setProjectInfo(title, state) {
				this.projectTitle = title;
				this.projectState = state;
				this.setOperationButtons(state);
			},

			getOptions() {
            	let url = config.api.options;
            	this.workflows = [];
				return this.HttpUtils.get(url, {}).then(result => {
					let options = result.data.options;
					options.forEach((opt, idx) => {
						this.workflows.push({
							value: idx,
							label: opt.reduce((prev, cur) => {prev.push(cur.option.title);return prev;}, []).join(","),
							// options: Object.assign(opt, {need_days: 0})
							options: opt.map(e => Object.assign(e, {need_days: 0}))
						});
					});

				}).catch(execption => {
					console.log(execption);
				});
            },

			setOperationButtons(state) {
				this.projectState = state;
				let userinfo = JSON.parse(localStorage.getItem("userinfo"));
				if (!userinfo || state === this.COLLECT_STATE.FINISH || state === this.COLLECT_STATE.TURN_OFF) {
					//跳转登录页面
					this.operationButtons = [];
					return;
				}
				switch (this.procedure_state) {
                     case 0:// 未配置
                        this.operationButtons = [{
							title: '配置流程',
							code: "CONFIG"
						}];
						break;
					case 1:// 配置
						this.operationButtons = [{
							title: '修改配置',
							code: "MODIFY"
						},{
							title: '新增手动任务',
							code: "MANUAL"
						}];
						break;
					default:
						break;
				}
			},
			//  PROJECT_LIST_CARD_OPERATION: {
			//   EDIT: '编辑',
			//   CLOSE: '关闭',
			//   START: '开始',
			//   START_TRY_COLLECT: '开始试采',
			//   FINISH_TRY_COLLECT: '试采通过',
			//   FINISH_PROJECT: '结束项目',
			//   FINISH_REOPEN: 'reopen',
			//   CLOSE_REOPEN: 'reopen',
			//   TURN_OFF: '已关闭',
			//   CHECK_SCENE_CONFIG: '查看配置文件',
			//   CREATE_SCENE_CONFIG: '生成配置文件',
			//   UPDATE_SCENE_CONFIG: '修改配置文件',
			//   CREATE_QRCODE: '生成二维码'
			// },
			operationButtonAction(value) {
				let userinfo = JSON.parse(localStorage.getItem("userinfo"));
				if (!userinfo) {
					//跳转登录页面
					eventBus.$emit('logout')
					return;
				}

				let code = value.code;
				switch (code) {
					case "CONFIG":
                    	this.getOptions().then(() => {
                    		this.workflowActon = "create";
	                    	this.workflow = this.workflows[0].value;
	                    	this.confirmConfigDialogShow = true;
                    	});
						break;
					case "MODIFY":
						this.getOptions().then(() => {
							this.workflowActon = "update";
							for (let i=0; i<this.workflows.length; i++) {
								let matched = true;
								for (let j=0; j<this.options.length; j++) {
									if (!this.workflows[i].options[j] || this.options[j].option.id !== this.workflows[i].options[j].option.id) {
										matched = false;
									}
								}
								if (matched) {
									this.workflow = this.workflows[i].value;
									this.workflows[i].options = JSON.parse(JSON.stringify(this.options));
								}
							}

							this.confirmConfigDialogShow = true;
						});
						break;
					case "MANUAL":
						this.confirmManualDialogShow = true;
						break;
					default:
						break;
				}
			},
			loadDateSets() {
				let url = config.api.data_sets + '/' + this.job_uid;
				return this.HttpUtils.get(url, {
					page: this.page,
					per_page: this.per_page,
					sorts: 'create_time|desc'
				}).then(result => {
					this.data_sets = result.data.items;
					this.total = result.data.pagination.total;
				}).catch(execption => {
					console.log(execption);
				});
			},
			updateState (id, option, options) {
				console.log('option....', option);
				if (option.state !== 0 || option.option.title.indexOf('上传') !== -1)return;

				let title, tip, hasNotFinished = false;
				options.forEach(opt => {
					if (opt.sequence < option.sequence && opt.state === 0){
						hasNotFinished = true;
					}
				});
				if (option.sequence === options[options.length - 1].sequence && hasNotFinished) {
					title = '完成全部流程';
					tip = '您确认完成该任务的全部流程吗？确认后将不可回退';
				} else {
					title = '完成当前流程';
					tip = '您确认完成该流程吗？确认后将不可回退';
				}
				MessageBox.confirm(tip, title).then(() => {
					let url = config.api.data_sets + '/procedures/' + id;
					this.HttpUtils.patch(url, {
						"sequence": option.sequence,
    					"state": 1
					}).then(result => {
						this.loadDateSets();
					}).catch(execption => {
						console.log(execption);
					});
				});
			},
			pageChange(val) {
				this.page = val;
				this.loadDateSets();
			},
			formateDate(row, column, value, index) {
				var date = new Date(value * 1000);
				var y = date.getFullYear();
				var m = date.getMonth() + 1;
				m = m < 10 ? "0" + m : m;
				var d = date.getDate();
				d = d < 10 ? "0" + d : d;
				// var h = date.getHours();
				// h = h < 10 ? ('0' + h) : h;
				// var minute = date.getMinutes();
				// var second = date.getSeconds();
				// minute = minute < 10 ? ('0' + minute) : minute;
				// second = second < 10 ? ('0' + second) : second;
				// return y + '-' + m + '-' + d+' '+h+':'+minute+':'+second;
				return y < 2000 ? '/' : y + "/" + m + "/" + d;
			},
			configProjectAction() {
				let url = config.api.job_procedure;
				let options;
				this.workflows.forEach(workflow => {
					if (this.workflow === workflow.value) {
						options = workflow.options;
					}
				});
				// 预计各节点所需时间校验
				// let hasError = false;
				// console.log('options',options)
				// options.forEach((opt, idx) => {
				// 	if (idx !== options.length - 1 && (window.isNaN(+this.curOption[idx].need_days) || +this.curOption[idx].need_days <= 0)) {
				// 		hasError = true;
				// 		this.$alert(opt.option.title + '所需天数填写错误' ,'提示');
				// 		return;
				// 	}
				// });
				// if(hasError) return;

				if (this.workflowActon === "create") {
					let fullscreenLoading = Loading.service({
						lock: true,
						text: "努力处理数据中，请稍候",
						spinner: "el-icon-loading",
						background: "rgba(0, 0, 0, 0.7)"
					})
					this.HttpUtils.post(url, {
						"job_uid": this.job_uid,
					    "options": options.map((opt,idx) => ({"sequence": opt.sequence, option_id: opt.option.id, need_days: this.curOption[idx].need_days}))
					}).then(result => {
						fullscreenLoading.close()
						document.location.reload()
					}).catch(execption => {
						fullscreenLoading.close()
						if (execption.code === 2011) {
							this.confirmConfigDialogShow = false
							this.centerDialogVisible = true
						}
					});
				} else {
					this.HttpUtils.patch(url + '/' + this.job_uid, {
					    "options": options.map((opt, idx) => ({"sequence": opt.sequence, option_id: opt.option.id, need_days: this.curOption[idx].need_days}))
					}).then(result => {
						document.location.reload();
					}).catch(execption => {
						console.log(execption);
					});
				}
			},
			manualProjectAction() {
				this.$refs.manualConfigForm.validate(valid => {
					if (valid) {
						let url = config.api.data_sets;
						this.HttpUtils.post(url, this.manualConfigForm).then(result => {
							this.confirmManualDialogShow = false;
							document.location.reload();
						}).catch(execption => {
							console.log(execption);
						});
					}
				});
			},
			clear() {
				this.manualConfigForm.oss_prefix = '';
				this.manualConfigForm.data_set_name = '';
				this.$refs.manualConfigForm && this.$refs.manualConfigForm.resetFields();
			},
			viewReport(row) {
				this.viewReportData = row.check_reports
				this.viewReportDialogShow = true
			},
			translateCode(row){
				switch (row.node) {
					case 201: return '处理后';break;
					case 200: return '回流时';break;
					default:return '';break;
				}
			},
			viewReportDetail(row){
				let firstNode,firstId,secondNode,secondId
				this.viewReportData.forEach((item,index) => {
					if(index === 0){
						firstNode = item.node
						firstId = item.id
					} else if(index === 1){
						secondNode = item.node
						secondId = item.id
					}
				})
				let routeUrl = this.$router.resolve({path: "/view-report", query: {id:row.id,node:row.node,firstNode:firstNode,firstId:firstId,secondNode:secondNode,secondId:secondId}});
				window.open(routeUrl.href, '_blank');
			}
		}
	};

</script>



// WEBPACK FOOTER //
// src/js/modules/project/ui/etl_project/project_detail/ProjectDetail.vue